import { styled, Typography, css } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import { fadeIn } from 'assets/styles/animations';
import Modal from 'components/Modal';
import BirthdayTitle from 'assets/icons/BirthdayTitle';
import AnimatedGiftBox from 'components/AnimatedGiftBox';

const centeredStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const iphoneSE = '667px';

const subtitleTextColor = palette.sunshine[900];

export const StyledModal = styled(Modal)`
  .MuiDialog-container {
    background-color: white;
  }

  .MuiPaper-root {
    overflow: hidden;

    ${theme.breakpoints.up('sm')} {
      max-width: 880px;
    }
  }
`;

export const Wrapper = styled('div')`
  ${centeredStyles};
  animation: ${fadeIn} 1s cubic-bezier(0, -0.1, 0, 1.5) 1s forwards;
  height: 100%;
  opacity: 0;
`;

export const Header = styled('div')`
  ${centeredStyles};
  flex: 1;
  justify-content: space-between;
  padding: 5rem 1rem 1rem;

  @media (max-height: ${iphoneSE}) {
    padding-top: 1.5rem;
  }

  ${theme.breakpoints.up('sm')} {
    padding-top: 3rem;
  }
`;

export const SubtitleText = styled(Typography)`
  color: ${subtitleTextColor};
  height: 60px;
  margin-bottom: 1.5rem;
  max-width: 460px;
  text-align: center;
`;

export const StyledBirthdayTitle = styled(BirthdayTitle)`
  margin-bottom: 2rem;
  max-width: 100%;

  @media (max-height: ${iphoneSE}) {
    max-width: 80%;
  }

  ${theme.breakpoints.up('sm')} {
    margin-bottom: 4rem;
  }
`;

export const StyledAnimatedGiftBox = styled(AnimatedGiftBox)`
  margin-bottom: 2rem;
  max-width: 200px;

  &:hover {
    cursor: pointer;
  }

  @media (max-height: ${iphoneSE}) {
    max-width: 110px;
  }
`;
